import { useSeoMeta } from "@unhead/vue";

export default function ({
  title,
  description,
}: {
  title?: string,
  description?: string,
}) {
  const _title = title ? `${title} | Era` : undefined;

  return useSeoMeta({
    title: _title,
    ogTitle: _title,
    twitterTitle: _title,
    description,
    ogDescription: description,
    twitterDescription: description,
  });
}
